import * as React from "react";
import * as PropTypes from "prop-types";

import { noop } from "../../../../../Common/TypingUtils";

type ScrollToCallback = (element: Element) => void;

export interface IScrollToContext {
    scrollTo(element: Element): void;
}

const ScrollToContext = React.createContext<ScrollToCallback>(noop);

export function useScrollTo(): ScrollToCallback {
    return React.useContext(ScrollToContext);
}

export const scrollToContextTypes = {
    scrollTo: PropTypes.func,
};

interface ScrollToProviderProps {
    value: ScrollToCallback;
    children: React.ReactNode;
}

export class ScrollToProvider extends React.Component<ScrollToProviderProps> {
    public static childContextTypes = scrollToContextTypes;

    public getChildContext(): IScrollToContext {
        return {
            scrollTo: this.props.value,
        };
    }

    public render(): JSX.Element {
        return <ScrollToContext.Provider value={this.props.value}>{this.props.children}</ScrollToContext.Provider>;
    }
}
